import "@sass/_main.scss";
// Has scrolled detection
var _body = document.body;
window.addEventListener("scroll", function(){
	var currentScroll = this.scrollY;
	if(currentScroll > 0 && _body.classList.contains('has-scrolled') === false){
		_body.classList.add('has-scrolled');
	}else if( currentScroll === 0 && _body.classList.contains('has-scrolled') === true){
		_body.classList.remove('has-scrolled');
	}
});

// Open navigation
$(document).on('click','#menuBtn',function(){
	this.classList.toggle("opened")
	this.setAttribute('aria-expanded', this.classList.contains('opened'));
	document.body.classList.toggle("navigation-open");
})

// Accordion toggle
var _accordionTitles = document.querySelectorAll(".accordion-item .title");
if(_accordionTitles.length > 0){
	for(var i=0; i < _accordionTitles.length; i++){
		(function (i) {
			_accordionTitles[i].addEventListener("click", function(){
				var _parent = this.parentElement;
				var _sibling = this.nextElementSibling;
				var _siblingInnerHeight = _sibling.children[0].clientHeight
				
				if(_parent.classList.contains("open")){
					_parent.classList.remove("open");
					_sibling.style.height = 0 + 'px';
				}else{
					_parent.classList.add("open");
					_sibling.style.height = _siblingInnerHeight + 'px';
				}
			})
		}).call(this, i);
	}
}

// Handle first click language switcher
var firstClick = true;
var _wpmlItemLink = document.querySelectorAll(".wpml-ls-item a");
if(_wpmlItemLink.length > 0){
	_wpmlItemLink[0].addEventListener("click", function(e){
		if(firstClick && document.body.classList.contains("wpml-dropdown-is-open") === false && window.innerWidth > 767){
			e.preventDefault();
			setTimeout(function(){
				firstClick = false;
				document.body.classList.add("wpml-dropdown-is-open");
			}, 50);
		}
	})
}
document.body.addEventListener("click", function(){
	if(document.body.classList.contains("wpml-dropdown-is-open") === true){
		firstClick = true;
		document.body.classList.remove("wpml-dropdown-is-open");
	}
});

if($('.responsive-table-wrapper').length > 0 )
{
	updateResponsiveTableClasses();
	window.onresize = updateResponsiveTableClasses;
	$(document).ready(function()
	{
		$('.responsive-table-wrapper .responsive-inner-wrapper').on('scroll', function (e)
		{
			const parent = $(e.currentTarget).closest('.responsive-table-wrapper');
			const horizontal = e.currentTarget.scrollLeft;
			if(horizontal !== 0)
			{
				parent.addClass('has-scrolled');
			}
			else
			{
				parent.removeClass('has-scrolled');
			}
			
			const max = e.currentTarget.scrollWidth - e.currentTarget.clientWidth;
			if(max === horizontal)
			{
				parent.addClass('has-scrolled-to-end');
			}
			else
			{
				parent.removeClass('has-scrolled-to-end');
			}
		})
	});
}


function updateResponsiveTableClasses()
{
	const tables = $('.responsive-table-wrapper');
	tables.each((i,el) => {
		const innerBounds = $(el).find('.responsive-inner-wrapper table')[0].getBoundingClientRect();
		const bounds =  $(el)[0].getBoundingClientRect();
		if(bounds.width < innerBounds.width)
		{
			$(el).addClass('is-scroll');
		}
		else
		{
			$(el).removeClass('is-scroll');
		}
	})
	
}
